import { CSSProperties, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Sidebar, CloseButton, BackArrow, Backdrop, Title } from "./styles";
import { Transition } from "react-transition-group";
import Icon from "../Icon";
import { AnimationFixed, Animation } from "../Animation";
import leftArrow from "../../assets/icons/go-back-arrow.svg";
import close from "../../assets/icons/close.svg";

interface ComponentProps {
  position: "left" | "right";
  children: React.ReactNode;
  visible: boolean;
  onClose?: () => void;
  closeType?: "close" | "back";
  style?: CSSProperties;
  width?: string;
  title: string | React.ReactNode;
  options?: {
    style?: CSSProperties;
    titleStyle?: CSSProperties;
  };
}

const Component = ({
  position,
  children,
  visible,
  onClose,
  closeType = "close",
  style,
  width = "400px",
  title,
  options,
}: ComponentProps) => {
  const [internalVisible, setInternalVisible] = useState(visible);
  const animation =
    position === "left" ? "fadeInSlideLeft" : "fadeInSlideRight";

  // Manejo de bloqueo de scroll
  useEffect(() => {
    if (visible) {
      document.body.style.height = "100%";
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.height = "";
      document.body.style.overflow = "";
    }

    return () => {
      // Cleanup por si se desmonta inesperadamente
      document.body.style.height = "";
      document.body.style.overflow = "";
    };
  }, [visible]);

  // Escuchar cambios externos en `visible`
  useEffect(() => {
    setInternalVisible(visible);
  }, [visible]);

  const handleClose = () => {
    setInternalVisible(false);
  };

  return ReactDOM.createPortal(
    <Transition
      in={internalVisible}
      timeout={300}
      unmountOnExit // ✅ Se destruye cuando termina de cerrarse
      onExited={() => {
        // Recién se llama cuando termina la animación
        onClose?.();
      }}
    >
      {(state) => (
        <>
          <AnimationFixed
            name={animation}
            className={`animation-${state}`}
            duration={0.5}
            width={width}
            position={position}
            style={style || {}}
          >
            <Sidebar {...options}>
              {closeType === "close" && (
                <CloseButton type="button" onClick={handleClose}>
                  <Icon
                    icon={close}
                    color="rgba(45, 52, 54, 0.75)"
                    size="24px"
                  />
                </CloseButton>
              )}

              <Title style={options?.titleStyle}>
                {closeType === "back" && (
                  <BackArrow type="button" onClick={handleClose}>
                    <Icon
                      icon={leftArrow}
                      color="rgba(45, 52, 54, 0.75)"
                      size="24px"
                    />
                  </BackArrow>
                )}
                <span>{title}</span>
              </Title>

              {children}
            </Sidebar>
          </AnimationFixed>

          <Animation name="fadeIn" className={`animation-${state}`}>
            <Backdrop onClick={handleClose} />
          </Animation>
        </>
      )}
    </Transition>,
    document.getElementById("sidebars") as HTMLElement
  );
};

export default Component;
